import { StaticQuery, graphql } from "gatsby";
import React from "react";
import { css } from "styled-components";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

// import DLMBg from "images/DLM.png";
// import Modules from "images/FLM.png";
import Modules2x from "images/FLM@2x.png";

const textStyles = css`
  @media screen and (min-width: ${getSize("tablet720")}) {
    float: right;
    width: 218px;
  }
  @media screen and (min-width: ${getSize("tablet768")}) {
    width: 233px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    width: 314px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    width: 340px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    width: 393px;
  }
`;

export const Flm = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
      @media screen and (min-width: ${getSize(
          "tablet960"
        )}) and (max-width: 1199px) {
        padding-right: 30px;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query FlexibleLoadManagementHeroImageQuery {
          file(relativePath: { eq: "DLM.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          css={`
            + picture > img,
            img {
              object-position: 27% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 45% 50%;
              }
              @media screen and (min-width: ${getSize("tablet960")}) {
                width: calc(100% + 150px) !important;
                object-position: -135px 3%;
              }
              @media screen and (min-width: ${getSize("desktop1200")}) {
                width: 100% !important;
                object-position: unset;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Image
      alt="Savant Power Companion Modules"
      src={Modules2x}
      css={`
        height: 364px;
        left: 0;
        margin: 0 auto;
        object-fit: cover;
        position: absolute;
        right: 0;
        top: 220px;
        width: 375px;

        @media screen and (min-width: ${getSize("mobile480")}) {
          top: 290px;
          width: 480px;
          height: 466px;
        }
        @media screen and (min-width: ${getSize("tablet720")}) {
          display: none;
        }
      `}
    />
    <Card
      css={`
        padding-top: 79px;
        @media screen and (min-width: ${getSize("mobile480")}) {
          padding: 105px 46px 48px 46px;
        }
        @media screen and (min-width: ${getSize("tablet720")}) {
          padding: 38px 46px 44px 46px;
          position: relative;
          width: 480px;
        }
        @media screen and (min-width: ${getSize("tablet768")}) {
          width: 512px;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
          padding: 42px 46px 48px 46px;
          width: 604px;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          width: 624px;
          padding: 40px 46px 46px 46px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 80px 70px 86px 70px;
          width: 794px;
        }
      `}
    >
      <img
        alt="Savant Power Companion Modules"
        src={Modules2x}
        css={`
          display: none;
          @media screen and (min-width: ${getSize("tablet720")}) {
            display: initial;
            height: 313px;
            left: -54px;
            position: absolute;
            top: 59px;
          }
          @media screen and (min-width: ${getSize("tablet768")}) {
            height: 333px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            left: -56px;
            height: 363px;
            top: 23px;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            left: -72px;
            height: 364px;
            top: 36px;
          }
          @media screen and (min-width: ${getSize("desktop1920")}) {
            height: 464px;
            left: -61px;
            top: 44px;
          }
        `}
      />
      <Header2 css={textStyles}>
        Smart Electrical Panel
        <Underlined />
      </Header2>
      <Paragraph
        css={`
      ${textStyles}
      @media screen and (min-width: ${getSize("desktop1200")}) {
        margin-top: 22px;
      }
    `}
      >
        Install the Savant Power Smart Electrical Panel with Companion Modules
        to monitor and control every circuit making for a complete smart home.
        Flexible Load Management optimizes energy use allowing custom critical
        loads and load shedding during peak-rate periods.
      </Paragraph>
    </Card>
  </Section>
);
